import React from 'react';
import './MessengerChatHeader.css';

export function MessengerChatHeader({
  title,
  afterTitle,
  statusLabel,
  online,
  right,
  headerClassName = 'chatAssistant__header',
  titleClassName = 'chatAssistant__title',
}: {
  title: React.ReactNode;
  afterTitle?: React.ReactNode;
  /** Строка статуса под именем: "онлайн", "5 минут назад", "" */
  statusLabel?: string;
  /** true — зелёная точка рядом с именем */
  online?: boolean;
  right?: React.ReactNode;
  headerClassName?: string;
  titleClassName?: string;
}): React.ReactNode {
  return (
    <div className={headerClassName}>
      <div className="chatAssistant__headerTop">
        <div className="chatAssistant__headerTitleGroup">
          <div className="chatAssistant__headerTitleRow">
            {online && <span className="chatHeader__onlineDot" aria-hidden />}
            <span className={titleClassName}>{title}</span>
          </div>
          {statusLabel && (
            <span className={`chatHeader__statusLabel${online ? ' chatHeader__statusLabel--online' : ''}`}>
              {statusLabel}
            </span>
          )}
        </div>
        {right != null && <div className="chatAssistant__headerRight">{right}</div>}
      </div>
      {afterTitle != null && <div className="chatAssistant__headerBottom">{afterTitle}</div>}
    </div>
  );
}
